/**
 * Which unit the nutrition screens count in — calories and grams, or points.
 *
 * A context of its own, separate from the provider that fills it (`NutritionDisplayProvider`):
 * dozens of leaf components read the mode, and they must not import `AuthContext` to do it — that
 * would drag the service → axios chain into every component test that renders one meal card.
 *
 * The default is CALORIES, which is also the answer for any tree without the provider: a component
 * rendered in isolation must not invent a unit.
 */

import { createContext, useContext } from "react";
import { CALORIES } from "../componenets/nutrition/v2/ui/nutritionUnits";
import type { NutritionDisplayMode } from "../componenets/nutrition/v2/ui/nutritionUnits";

export const NutritionDisplayContext = createContext<NutritionDisplayMode>(CALORIES);

export function useNutritionDisplayMode(): NutritionDisplayMode {
  return useContext(NutritionDisplayContext);
}
